import Vue from "vue";
import Vuex from "vuex";


import { Notify } from 'quasar'


Vue.use(Vuex);


// var URL = 'http://server-latihan.simcard.konaweselatankab.go.id/';
// var URL = 'http://localhost:5012/';
// var URL = 'http://192.168.1.167:5012/';

var URL = 'https://server-simcard.konaweselatankab.go.id/'
// var URL = 'http://server-simcard.konaweselatankab.go.id/'
// var URL = 'http://10.91.178.2:5012/'
// var URL = 'http://server-latihan-simcard.konaweselatankab.go.id/'
// var URL = 'http://36.94.6.244:5012/'
// var URL = 'http://192.168.128.93:5051/'
// var URL = 'http://192.168.128.9:5051/'

export default new Vuex.Store({
  state: {
    leftDrawerOpen:false,
    _modal:{
      _add:false, 
      _edit:false, 
    },

    modal_loading:false,

    url: {
      URL_APP: URL,
      URL_APPX: URL,
      AUTH : URL + "auth/signup",
      URL_DASHBOARD: URL + 'api/v1/dashboard/',
      URL_MENU_LIST: URL + 'api/v1/menuList/',
      URL_LEVEL_USERS: URL + 'api/v1/levelUsers/',
      URL_REGISTRASI: URL + 'api/v1/pengaturan_registrasi/',

      URL_DATAMASTER_WILAYAH            : URL + 'api/v1/m_provinsi/',
      URL_DATAMASTER_KAB_KOTA           : URL + 'api/v1/m_kabupaten/',
      URL_DATAMASTER_KECAMATAN          : URL + 'api/v1/m_kecamatan/',
      URL_DATAMASTER_DES_KEL            : URL + 'api/v1/m_desa_kelurahan/',

      URL_MASTER_PENDIDIKAN             : URL + 'api/v1/m_list_pendidikan/',
      URL_MASTER_PEKERJAAN              : URL + 'api/v1/m_list_pekerjaan/',
      URL_MASTER_AGAMA                  : URL + 'api/v1/m_list_agama/',

      URL_MASTER_SHDK                  : URL + 'api/v1/m_list_SHDK/',

      URL_MASTER_PKL_JENIS_KELAHIRAN    : URL + 'api/v1/m_pkl_jenis_kelahiran/',
      URL_MASTER_PKL_PENOLONG_KELAHIRAN : URL + 'api/v1/m_pkl_penolong_kelahiran/',
      URL_MASTER_PKL_TEMPAT_DILAHIRKAN  : URL + 'api/v1/m_pkl_tempat_dilahirkan/',

      URL_PERMOHONAN_KTP              : URL + 'api/v1/permohonanKTP/',

      URL_PERMOHONAN_KELAHIRAN        : URL + 'api/v1/permohonanKELAHIRAN/',
      URL_PERMOHONAN_KELAHIRAN_AYTDAU : URL + 'api/v1/permohonanKELAHIRAN_aytdau/',

      // LAPOR KEMATIAN
      URL_PELAPORAN_LAHIR_MATI  : URL + 'api/v1/pelaporan_LAHIR_MATI/',
      URL_PELAPORAN_MATI        : URL + 'api/v1/pelaporan_MATI/',
      // LAPOR KEMATIAN

      URL_PERMOHONAN_KK_BARU    : URL + 'api/v1/permohonan_KK_baru/',
      URL_PERMOHONAN_KK_WNI     : URL + 'api/v1/permohonan_KK_WNI/',
      URL_PERMOHONAN_KK_WNA     : URL + 'api/v1/permohonan_KK_WNA/',

      URL_PERMOHONAN_PPD1       : URL + 'api/v1/permohonan_PPD1/',
      URL_PERMOHONAN_PPD2       : URL + 'api/v1/permohonan_PPD2/',
      URL_PERMOHONAN_PPD3       : URL + 'api/v1/permohonan_PPD3/',
      URL_WA_API                : URL + 'api/v1/wa_api/',
    },

    listPekerjaan:[],
    listAgama:[],
    listPendidikan:[],

    listMenu : [],
    lcProfile : null,

    // seting cssnya 
    warna_n : 'red-8' ,
    warna_y : 'blue-8' , 
    // seting cssnya 
    cari:'',

    // Data master
    // m_provinsi: "",
    // m_kabupaten: "",
    // m_kecamatan: "",
    // m_desa_kelurahan: "",
    // m_type_desa_kelurahan:null,
    // m_desa: "",

    kd_provinsi: "",
    kd_kabupaten: "",
    kd_kecamatan: "",
    kd_desa_kelurahan: "",
    // kd_desa: "",

    form: {
      // Laporan Lahir Mati
      hari:"",
      nama_hari : ['Senin','Selasa','Rabu','Kamis','Jumat','Sabtu','Minggu'],
      pukul:"",
      tanggal:"",
      tempat:"",
      jk_bayi:"", 
      jenis_lahir:"", 
      lama_mengandung:"", 
      alasan_kematian:"", 

      
      jenis_pekerjaan: [ "Belum/Tidak Bekerja",
        "Mengurus Rumah Tangga",
        "Pelajar/Mahasiswa",
      ],

    // ibu 
      // nama_ibu:"", 
      // nik_ibu:"", 
      // nkk_ibu:"", 
      // n_paspor_ibu:"", 
      // tmpt_lahir_ibu:"", 
      // tgl_lahir_ibu:"", 
      // kewarganegaraan_ibu:"", 
      // kewarganegaraan_ibu_lainnya:"", 
      // pekerjaan_ibu:"", 
      // alamat_ibu:"", 
      // provinsi_ibu:"", 
      // kabupaten_ibu:"", 
      // kecamatan_ibu:"", 
      // desa_ibu:"",
      // rt_ibu:"", 
      // rw_ibu:"", 
      // kode_pos_ibu:"", 
      // no_telp_ibu:"",  
      // pendidikan_terakhir_ibu:"",       
      // agama_ibu:"",       
      // agama_ibu_lainnya:"",           

      // tgl_catatan_perkawinan:"",       
    // ibu 

      
    // ayah      
      // nama_ayah:"", 
      // nik_ayah:"", 
      // nkk_ayah:"", 
      // n_paspor_ayah:"", 
      // tmpt_lahir_ayah:"", 
      // tgl_lahir_ayah:"", 
      // kewarganegaraan_ayah:"", 
      // kewarganegaraan_ayah_lainnya:"", 
      // pekerjaan_ayah:"", 
      // alamat_ayah:"", 
      // provinsi_ayah:"", 
      // kabupaten_ayah:"", 
      // kecamatan_ayah:"", 
      // desa_ayah:"", 
      // rt_ayah:"", 
      // rw_ayah:"", 
      // kode_pos_ayah:"", 
      // no_telp_ayah:"",       

      // pendidikan_terakhir_ayah:"",       
      // agama_ayah:"",       
      // agama_ayah_lainnya:"",       
      // perceraian_ayah_ke:"",       
    // ayah      

      // Laporan Lahir Mati
      
      // SK KeLahiran
      
      
      // nama_bayi:"",
      // jenis_kelamin_bayi:"",
      // tmpt_lahir_bayi:"",
      // tmpt_lahir_bayi_lainnya:"",
      // tempat_kelahiran_bayi:"",
      // tgl_lahir_bayi:"",
      // jenis_lahir:"", 
      // jenis_lahir_lainnya:"", 
      // kelahiran_ke:"", 
      // penolong_kelahiran:"", 
      // penolong_kelahiran_lainnya:"", 
      // berat_bayi:"", 
      // panjang_bayi:"", 





    // pelapor
      // nik_pelapor             :"", 
      // nama_pelapor            :"", 
      // umur_pelapor            :"",  
      // pekerjaan_pelapor       :"", 
      // provinsi_pelapor        :"", 
      // kabupaten_pelapor       :"", 
      // kecamatan_pelapor       :"", 
      // desa_pelapor            :"", 
      // alamat_pelapor          :"", 
      // jk_pelapor              :"", 
    // pelapor

    // _saksi1
      // nik_saksi1             :"", 
      // nama_saksi1            :"", 
      // umur_saksi1       :"",  
      // pekerjaan_saksi1       :"", 
      // provinsi_saksi1        :"", 
      // kabupaten_saksi1       :"", 
      // kecamatan_saksi1       :"", 
      // desa_saksi1            :"", 
      // alamat_saksi1          :"", 
    // _saksi1

    // _saksi2
      // nik_saksi2             :"", 
      // nama_saksi2            :"", 
      // umur_saksi2       :"",  
      // pekerjaan_saksi2       :"", 
      // provinsi_saksi2        :"", 
      // kabupaten_saksi2       :"", 
      // kecamatan_saksi2       :"", 
      // desa_saksi2            :"", 
      // alamat_saksi2          :"", 
    // _saksi2

      // nik             :"", 
      // nama            :"", 
      // umur            :"",  
      // pekerjaan       :"", 
      // provinsi        :"", 
      // kabupaten       :"", 
      // kecamatan       :"", 
      // desa            :"", 
      // alamat          :"", 

      // SK KeLahiran 

      // tujuan pengiriman
      tujuan_provinsi: "",
      tujuan_kabupaten: "",
      tujuan_kecamatan: "",
      tujuan_kelurahan: "",
      tujuan_desa: "",
      // tujuan pengiriman

      permohonan_ktp: "",

      permohonan: "",
      keterangan_lainnya: "",

      file: "",
      nama: "",
      no_kk: "",
      nik: "",
      alamat: "",
      rt: "",
      rw: "",
      kode_pos: "",
      telepon: "",
      umur:"",
      pekerjaan:"",


      alasan_penolakan: "",
      alasan_diterima: "",

  // daerah_input
        provinsi: "",
        kabupaten: "",
        kecamatan: "",
        kelurahan: "",
        desa: "",
        dusun:"",
  // daerah_input

      list_anggota_keluarga: [],
      data: [],
      anggota_keluarga: {
        no_kk: "",
        nama: "",
      },
      // Data sebelumnya
      nama_kepala_keluarga: "",
      nama_kepala_keluarga_lama: "",
      no_kk_lama: "",
      alamat_keluarga_lama: "",
      rt_lama: "",
      rw_lama: "",

      provinsi_lama: "",
      kabupaten_lama: "",
      kecamatan_lama: "",
      desa_lama: "",
      kode_pos_lama: "",
      telepon_lama: "",
      // Data sebelumnya

      no_kitap: "",
      no_kitap: "",
      expire_kitap: "",
      
      terusan_ke_kabupaten: "",
      modul: "",

  // data_kepindahan (baru)
    alamat_pindah_ppd:"", 

    rt_ppd: "",
    rw_ppd: "",

    provinsi_ppd: "",
    kabupaten_ppd: "",
    kecamatan_ppd: "",
    desa_ppd: "",
    dusun_ppd:"",

    kode_pos_ppd: "",
    telepon_ppd: "",    

    jenis_kepindahan: "",
    status_kk_bagi_yg_tidak_pindah: "",
    status_kk_bagi_yg_pindah: "",
 

    keluarga_yg_pindah: {
      nik: "",
      nama: "",
      masa_berlaku_ktp_dari: "",
      masa_berlaku_ktp_hingga: "",
      shdk: "",
      // Status Hubungan Dalam Keluarga (shdk)
    },
    list_keluarga_yg_pindah:[], 
  // data_kepindahan (baru) 
    },

    // modal

    modal: false,
    modal_edit: false,
    modal_hapus: false,
    
    modal_terima:false,
    modal_tolak:false,

    modal_hapus_keluarga: false,

    modal_anggota_keluarga: false,
    modal_edit_anggota_keluarga: false,
    modal_lihat: false,
    modal_lihat_alasan: false,
    modal_lihat_alasan_diterima: false,
    verifikasi_data: false,
    tolak: false,
    terima: false,
    modal_anggota_keluarga: false,
    modal_edit_anggota_keluarga: false,
    
    verifikasi_data_kabupaten: false,
    tolak_kabupaten: false,
    terima_kabupaten: false,
    
    terusan_kabupaten: false,

    
    modal_file_img: false,
    modal_file_pdf: false,
    
    // TOLONG CHECK APAKAH DIGUNAKAN
    btn: {
      add: false,
      edit: false,
      remove: false,
    },
    // TOLONG CHECK APAKAH DIGUNAKAN

    btnAkses: {
      add: false,
      edit: false,
      remove: false,
      reject: false,
      approve: false,
    },
  },
  mutations: {
    addanggota_keluarga(state ){
      var arr = state.form.list_anggota_keluarga;
      // var data = {
        //   no_kk : state.form.anggota_keluarga.no_kk,
        //   nama  : state.form.anggota_keluarga.nama,
        // }
      arr.push(state.form.anggota_keluarga);

      state.form.anggota_keluarga = {
        no_kk: "",
        nama: "",
      }

    },

    add_keluarga_yg_pindah(state ){
      var arr = state.form.list_keluarga_yg_pindah;
      // var data = {
      //   no_kk : state.form.anggota_keluarga.no_kk,
      //   nama  : state.form.anggota_keluarga.nama,
      // }
      arr.push(state.form.keluarga_yg_pindah);

      state.form.keluarga_yg_pindah = {
        nik: "",
        nama: "",
        masa_berlaku_ktp_dari: "",
        masa_berlaku_ktp_hingga: "",
        shdk: "",
      }

    },

    add_data(){
      
    },

    update (nik){
      // ambil id duulu
      // langsung data.nama = apa?

      // var arr = state.form.list_keluarga_yg_pindah;
      // // var data = {
      // //   no_kk : state.form.anggota_keluarga.no_kk,
      // //   nama  : state.form.anggota_keluarga.nama,
      // // }
      // arr.push(state.form.keluarga_yg_pindah);

      // if (state.form.keluarga_yg_pindah.nik = ) {
        
      // }

      // state.form.keluarga_yg_pindah = {
      //   nik: "",
      //   nama: "",
      //   masa_berlaku_ktp_dari: "",
      //   masa_berlaku_ktp_hingga: "",
      //   shdk: "",
      // }     
      
      console.log();
    },
    notif_berhasil () { 
      Notify.create({
        message: "Data berhasil dimasukan",
        color: 'green',
        icon: 'fa fa-check',
        timeout: 500,
      })
    },
    notif_berhasil_menghapus () { 
      Notify.create({
        message: 'Berhasil menghapus data',
        color: 'green',
        icon: 'fa fa-check',
        timeout: 500,
      })
    },
    notif_edit () { 
      Notify.create({
        message: 'Berhasil mengedit data',
        color: 'green',
        icon: 'fa fa-check',
        timeout: 500,
      })
    },
    notif_terbit () { 
      Notify.create({
        message: 'Berhasil Menerbitkan File',
        color: 'green',
        icon: 'fa fa-check',
        timeout: 500,
      })
    },
    notif_gagal () {
      Notify.create({
        message: this.pesanGagal,
        color: 'red',
        icon: 'fa fa-exclamation-triangle',
        timeout: 500,
      })
    },
    
  },
  actions: {},
  modules: {},
});
